import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
} from "@angular/forms";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { ServiceToOffer } from "src/app/core/models/healthSystem/serviceToOffer";
import { CommonService } from "src/app/core/services/v2/common.service";
import { Insurance } from "../../../../core/model/v2/insurance";
import * as _ from "lodash";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Specialty } from "src/app/core/model/v2/specialty";
import { Services } from "src/app/core/model/v2/practice/Services";
import { concat } from "rxjs";
import { UtilsService } from "../../../../core/services/v2/utils.service";

@Component({
  selector: "app-edit-practice",
  templateUrl: "./edit-practice.component.html",
  styleUrls: ["./edit-practice.component.scss"],
})
export class EditPracticeComponent implements OnInit {
  @Input() practiceData;
  @Output() toggleSidebar = new EventEmitter();
  @Output() isAboutSaved = new EventEmitter<boolean>(false);
  address1: string;
  practiceName: string;
  city: string;
  state: string;
  zip: string;
  bio: string;
  healthSystemServices: [];
  healthSystemInsurance: [];
  statesCodes: CodeTable;
  serviceTypes: ServiceToOffer[];
  tempServiceTypes: ServiceToOffer[];
  updatedServiceTypes: ServiceToOffer[];
  insurances: Insurance[];
  specialties: Specialty[];
  healthSystemSpecialty: any;
  healthSystemSubSpecialty: any;
  selectedCategoryId: number;
  specializationCategories: any;
  editPracticeForm: FormGroup = this.fb.group({

    specialty: [''],
    subSpecialty: [''],
    phone: [''],
    fax: [''],
    practiceName: [{ value: '', disabled: true }],
    address1: ['', Validators.required],
    address2: [''],
    city: ['', Validators.required],
    state: ['', Validators.required],
    zip: ['', Validators.required],
    NPInumberFormControl: [''],
    workingHours: this.fb.array([this.fb.group({
      day: [''],
      timeFrom: [''],
      timeTo: [''],
      isClosed: [false],
    })]
    ),
    bio: [''],
    healthSystemServices: [''],
    healthSystemInsurance: [''],
  });
  workingDaysHours: any;
  workingHoursJson = [
    {
      day: "Monday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
    {
      day: "Tuesday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
    {
      day: "Wednesday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
    {
      day: "Thursday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
    {
      day: "Friday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
    {
      day: "Saturday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
    {
      day: "Sunday",
      fromTime: "",
      toTime: "",
      isClosed: false,
    },
  ];
  public model = {

    name: 'Hardik',

    description: '<p>This is a sample form using CKEditor 4.</p>'

  };

  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private _practiceService: PracticeService,
    private _loaderService: WindowLoaderService,
    private _utls: UtilsService
  ) { }

  get workingHours() {
    return this.editPracticeForm.get("workingHours") as FormArray;
  }

  ngOnInit() {
    this.getSpecialities();
    //this.initializePracticeData();
  }

  initializePracticeData() {
    this.getSates();
    this.getServiceTypes();
    this.getAllInsurances();
    this.selectedCategoryId = this.specialties.find(x => x.name == this.practiceData.specialty) != undefined ? this.specialties.find(x => x.name == this.practiceData.specialty).id:0;
    if (this.selectedCategoryId > 0) {
      this.fillSpecializationCategory(this.selectedCategoryId);
    }
    //this.getSpecialities();
    //this.workingDaysHours = [...this.workingHoursJson];
    let workingHrs = [];
    // workingHrs = this.practiceData.workingHours;
   const specialty = this.practiceData ? this.specialties.find(x=>x.name == this.practiceData.specialty) : [];
    this.editPracticeForm = this.fb.group({
      //specialty: new FormControl(
      //  this.practiceData ? this.practiceData.specialty : ""
      //),
      specialty: [specialty ?  specialty['id'] : []],
      subSpecialty: [this.practiceData ? this.practiceData.subSpecialty : []],
      phone: [this.practiceData ? this.practiceData.primaryPhoneNumber : ""],
      fax: [this.practiceData ? this.practiceData.faxNumber : ""],
      practiceName: [this.practiceData ? this.practiceData.otherOrganizationName : ""],
      address1: [
        this.practiceData ? this.practiceData.location.address1: "",
        [Validators.required],
      ],
      address2: [this.practiceData ? this.practiceData.location.address2 : ""],
      city: [
        this.practiceData.location ? this.practiceData.location.city : "",
        [Validators.required],
      ],
      state: [
        this.practiceData.location ? this.practiceData.location.state : [],
        [Validators.required],
      ],
      zip: [
        this.practiceData.location ? this.practiceData.location.zipCode : "",
        [Validators.required],
      ],
      NPInumberFormControl: [this.practiceData.npi ? this.practiceData.npi:""
      ],
      workingHours: this.fb.array(
        (this.practiceData.workingHours && this.practiceData.workingHours.length>0)
          ? this.practiceData.workingHours.map((workings) => {
            return this.fb.group({
              day: workings.day,
              timeFrom:
                workings.hours[0] != ""
                  ? workings.hours[0].split("-")[0].trim()
                  : "",
              timeTo:
                workings.hours[0] != ""
                  ? workings.hours[0].split("-")[1].trim()
                  : "",
              isClosed: workings.hours[0] == "" ? false : false,
            });
          })
          : [this.fb.group({
            day: [''],
            timeFrom: [''],
            timeTo: [''],
            isClosed: [false],
          })]
      ),
      bio: new FormControl(this.practiceData ? this.practiceData.bio : ""),
      healthSystemServices: new FormControl(
        this.practiceData
          ? this.practiceData.healthSystemServices.map((hs) => {
            return hs;
          })
          : [],
        []
      ),
      healthSystemInsurance: new FormControl(
        this.practiceData
          ? this.practiceData.healthSystemInsurance.map((selval) => {
            return selval;
          })
          : []
      ),
    });
  }

  getSates() {
    this.commonService.GetItemsByCodeNamesWithoutCache(["STATE"]).subscribe(
      (codeTables) => {
        this.statesCodes = codeTables.codeTable[0];
      },
      (error) => console.log(error)
    );
  }

  async getServiceTypes() {
    await this.commonService.getServicesToOffer().subscribe((res) => {
      this.serviceTypes = res.result;
    });
  }

  setTime(i) {
    let workingHrsArr = this.getWorkingHoursDetails();
    workingHrsArr.removeAt(i);
  }
  getWorkingHoursDetails(): FormArray {
    return this.editPracticeForm.get('workingHours') as FormArray;
  }
  addNewDay() {
    let workingHrsArr = this.editPracticeForm.get('workingHours') as FormArray;
    let newWorkingHrsEntry = this.fb.group({
      day: '',
      timeFrom: '',
      timeTo: ''
    })
    workingHrsArr.push(newWorkingHrsEntry);
  }

  getAllInsurances() {
    this.commonService.getInsurances().subscribe(
      (list) => {
        this.insurances = list.insurances;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getSpecialities() {
   this.commonService.getSpecialty().subscribe((response) => {
     this.specialties = response.specialties;
     this.initializePracticeData();
    });
  }

  onSelectServices(service: Services): void {
    if (!service.id) {
      this._loaderService.show();
      this._practiceService.addnewService(service.name).subscribe(
        (s) => {
          this._loaderService.hide();
          if (s) {
            if (s.resultStatus.isSuccess) {
              this.editPracticeForm.value.healthSystemServices.push(s.result);
            }
          }
        },
        (error) => {
          console.error(error);
          this._loaderService.hide();
        }
      );
    } else {
    }
  }

  cancel() {
    this.toggleSidebar.emit();
    this.isAboutSaved.emit(true);
  }

  updatePracticeData() {
    //let arrAddress = this.editPracticeForm.value
    //  ? this.editPracticeForm.value.address1.split(',') : this.editPracticeForm.value;
    //let i: number = 0;
    //let paddr1 = arrAddress[0];
    //let paddr2 = arrAddress[1];
    //let pcity = arrAddress[2];
    //let pstate = arrAddress[3];
    //let pzip = arrAddress[4];
    //while (i<arrAddress.length)
    //{
    //  switch (i) {
    //    case 0:
    //      paddr1 = arrAddress[i];          
    //      break
    //    case 1:
    //      paddr2 = arrAddress[i];
    //      break
    //    case 2:
    //      pcity = arrAddress[i];
    //      break
    //    case 3:
    //      pstate = arrAddress[i];
    //      break
    //    case 4:
    //      pzip = arrAddress[i];
    //      break
    //  }
    //  i++;
    //}
    let workingHr = this.editPracticeForm.value.workingHours.map((wh) => {
      return {
        day: wh.day,
        hours: [wh.isClosed ? "Closed" : wh.timeFrom + "-" + wh.timeTo],
      };
    });
    
    let servicesToOffer =
      this.editPracticeForm.value.healthSystemServices.filter(
        (serv) => serv.id
      );
    let data = {
      healthSystemAboutMe: {
        healthSystemId: this.practiceData ? this.practiceData.id : null,
        aboutUs: this.editPracticeForm.value
          ? this.editPracticeForm.value.bio
          : this.practiceData.bio,
      },
      healthSystemFile: {
        healthSystemId: this.practiceData ? this.practiceData.id : null,
        imageSource: this.practiceData ? this.practiceData.photoUrl : null,
      },
      healthSystemInsurancePlan: {
        healthSystemId: this.practiceData ? this.practiceData.id : null,
        healthSystemInsurancePlanIds: this.editPracticeForm.value
          ? this.editPracticeForm.value.healthSystemInsurance.map((val) => {
            return val.id;
          })
          : [],
      },
      healthSystemServiceToOffer: {
        healthSystemId: this.practiceData ? this.practiceData.id : null,
        healthSystemServicesToOffer: this.editPracticeForm.value
          .healthSystemServices
          ? servicesToOffer.map((hs) => {
            return hs.id;
          })
          : [],
      },
      healthSystemContactInfo: {
        healthSystemId: this.practiceData ? this.practiceData.id : null,
        primaryPhoneNumber: this.editPracticeForm
          ? this.editPracticeForm.value.phone
          : this.practiceData.primaryPhoneNumber,
        practiceName: this.editPracticeForm
          ? this.editPracticeForm.value.practiceName
          : this.practiceData.otherOrganizationName,
        faxNumber: this.editPracticeForm.value
          ? this.editPracticeForm.value.fax
          : this.practiceData.faxNumber,
        specialty: this.editPracticeForm.value
          ? this.specialties.find(x => x.id == this.editPracticeForm.value.specialty).name
          : this.practiceData.specialty,
        subSpecialty: this.editPracticeForm.value
          ? this.specializationCategories.find(x => x.id == this.editPracticeForm.value.subSpecialty).name
          : this.practiceData.subSpecialty,
        location: {
          id: this.practiceData.location ? this.practiceData.location.id : null,
          status: this.practiceData.location
            ? this.practiceData.location.status
            : null,
          name: this.practiceData.location
            ? this.practiceData.location.name
            : null,
          description: this.practiceData.location
            ? this.practiceData.location.description
            : null,
          primaryPhoneNumber: this.practiceData.location
            ? this.practiceData.location.primaryPhoneNumber
            : null,
          webAddress: this.practiceData.location
            ? this.practiceData.location.webAddress
            : null,
          address1: this.editPracticeForm.value
            ? this.editPracticeForm.value.address1
            : this.practiceData.location.address1,
          address2: this.editPracticeForm.value
            ? this.editPracticeForm.value.address2
            : this.practiceData.location.address2,
          city: this.editPracticeForm.value
            ? this.editPracticeForm.value.city
            : this.practiceData.location.city,
          state: this.editPracticeForm.value
            ? this.editPracticeForm.value.state
            : this.practiceData.location.state,
          zipCode: this.editPracticeForm.value
            ? this.editPracticeForm.value.zip
            : this.practiceData.location.zipCode,
          country: this.practiceData.location
            ? this.practiceData.location.country
            : null,
          hours: this.practiceData.location
            ? this.practiceData.location.hours
            : null,
          fax: this.practiceData.location
            ? this.practiceData.location.fax
            : null,
          cleanZipCode: this.practiceData.location
            ? this.practiceData.location.cleanZipCode
            : null,
          latitude: this.practiceData.location
            ? this.practiceData.location.latitude
            : null,
          longitude: this.practiceData.location
            ? this.practiceData.longitude
            : null,
          globalLocationId: this.practiceData.location
            ? this.practiceData.location.globalLocationId
            : null,
        },
        workingHours: this.editPracticeForm.value
          ? workingHr
          : this.practiceData.workingHours,
      },
    };
    this._loaderService.show();
    this._practiceService.updateHealthSystemInfo(data).subscribe((res) => {
      this._loaderService.hide();
      //this.toggleSidebar.emit();
      this.isAboutSaved.emit(true);
    });
       
  }
   fillSpecializationCategory(event: any) {
    this.selectedCategoryId = this.editPracticeForm != undefined ? this.editPracticeForm.value.specialty == undefined ? this.selectedCategoryId : this.editPracticeForm.value.specialty : this.selectedCategoryId;
    this.editPracticeForm?this.editPracticeForm.controls["subSpecialty"].setValue(""):"";
    this.specializationCategories = [];
    //this.editProviderForm.controls['specializationFormControl'].setValue("");
    let spCatValue = this.selectedCategoryId;
    spCatValue = spCatValue == undefined ? 0 : spCatValue;
    let id = event.value ? event.value : event;
    this._loaderService.show();
    this.commonService.GetSpecialization(id).subscribe((details) => {
      if (details.response.isSuccess) {
        this.specializationCategories = details.specialties;
        if (this.specializationCategories.find(x => x.name == this.practiceData.subSpecialty) != undefined) {
          this.editPracticeForm.controls["subSpecialty"].setValue(this.specializationCategories.find(x => x.name == this.practiceData.subSpecialty).id);
        }
        
      }
      this._loaderService.hide();
    });

  }
  checkDays(i, dayName?: string) {

    let count: number = 0;
    let workingHrsArr = this.editPracticeForm.get('workingHours') as FormArray;

    workingHrsArr.controls.filter((x) => x.value.day == (dayName != undefined ? dayName : workingHrsArr.controls[i].value.day)).forEach(element => {
      count++;
    });

    if (count > 1) {
      this._utls.showMessageSnackBar("Duplicate day selected!", true);
      // workingHrsArr.controls.splice(i, 1);
      return false;
    }
    else {
      return true;
    }
  }
  
}
